import { createSlice } from "@reduxjs/toolkit";

import { surveillanceProductCategoryOption } from "../../../../../pages/Devices/AddDevice/Suvillance/const";

export const mockSurveillanceDiscoveredDevices = [
  {
    brandName: "D-LINK",
    productName: "D-Link NVR",
    modelName: "DNR-4020-16P",
    version: "1.10.03",
    deviceId: "0c:b6:d2:fa:45:30",
    ipStatus: 1,
    ipAddress: "192.168.1.100",
    webPortNumber: 443,
    subnetMask: "255.255.255.0",
    defaultGateway: "192.168.1.1",
    primaryDNS: "8.8.8.8",
    secondaryDNS: "0.0.0.0",
    dhcpEnable: 1,
    productCategory: surveillanceProductCategoryOption.nvr,
    hardwareRevision: "A1",
    deviceIPType: 0,
    managedByNMS: 0,
    nmsURL: "",
    mgmtStatus: 1,
    mgmtMode: "UNP",
    authStatus: "passed",
    protocolType: "sunell",
  },
  {
    brandName: "D-LINK",
    productName: "D-Link Camera",
    modelName: "DCS-8635LH",
    version: "2.00.01",
    deviceId: "0c:b6:d2:fa:45:31",
    ipStatus: 1,
    ipAddress: "192.168.1.101",
    webPortNumber: 443,
    subnetMask: "255.255.255.0",
    defaultGateway: "192.168.1.1",
    primaryDNS: "8.8.8.8",
    secondaryDNS: "0.0.0.0",
    dhcpEnable: 1,
    productCategory: surveillanceProductCategoryOption.ipcam,
    hardwareRevision: "A2",
    deviceIPType: 0,
    managedByNMS: 0,
    nmsURL: "",
    mgmtStatus: 1,
    mgmtMode: "UNP",
    authStatus: "failed",
    protocolType: "sunell",
  },
  {
    brandName: "D-LINK",
    productName: "D-Link Camera",
    modelName: "DCS-8302LH",
    version: "1.04.07",
    deviceId: "0c:b6:d2:fa:45:32",
    ipStatus: 1,
    ipAddress: "192.168.1.102",
    webPortNumber: 443,
    subnetMask: "255.255.255.0",
    defaultGateway: "192.168.1.1",
    primaryDNS: "8.8.8.8",
    secondaryDNS: "0.0.0.0",
    dhcpEnable: 1,
    productCategory: surveillanceProductCategoryOption.ipcam,
    hardwareRevision: "A1",
    deviceIPType: 0,
    managedByNMS: 0,
    nmsURL: "",
    mgmtStatus: 1,
    mgmtMode: "UNP",
    authStatus: "passed",
    protocolType: "sunell",
    username: "operator",
    password: "operator123",
  },
  {
    brandName: "D-LINK",
    productName: "D-Link NVR",
    modelName: "DNR-2020-04P",
    version: "1.08.02",
    deviceId: "0c:b6:d2:fa:45:33",
    ipStatus: 1,
    ipAddress: "192.168.1.103",
    webPortNumber: 443,
    subnetMask: "255.255.255.0",
    defaultGateway: "192.168.1.1",
    primaryDNS: "8.8.8.8",
    secondaryDNS: "0.0.0.0",
    dhcpEnable: 1,
    productCategory: surveillanceProductCategoryOption.nvr,
    hardwareRevision: "B1",
    deviceIPType: 0,
    managedByNMS: 0,
    nmsURL: "",
    mgmtStatus: 1,
    mgmtMode: "UNP",
    authStatus: "failed",
    protocolType: "sunell",
  },
  {
    brandName: "D-LINK",
    productName: "D-Link Camera",
    modelName: "DCS-4618EK",
    version: "2.12.00",
    deviceId: "0c:b6:d2:fa:45:34",
    ipStatus: 1,
    ipAddress: "192.168.1.104",
    webPortNumber: 443,
    subnetMask: "255.255.255.0",
    defaultGateway: "192.168.1.1",
    primaryDNS: "8.8.8.8",
    secondaryDNS: "0.0.0.0",
    dhcpEnable: 1,
    productCategory: surveillanceProductCategoryOption.ipcam,
    hardwareRevision: "A3",
    deviceIPType: 0,
    managedByNMS: 0,
    nmsURL: "",
    mgmtStatus: 1,
    mgmtMode: "UNP",
    authStatus: "passed",
    protocolType: "sunell",
  },
  {
    brandName: "D-LINK",
    productName: "D-Link Camera",
    modelName: "DCS-4718E",
    version: "1.20.04",
    deviceId: "0c:b6:d2:fa:45:35",
    ipStatus: 1,
    ipAddress: "192.168.1.105",
    webPortNumber: 443,
    subnetMask: "255.255.255.0",
    defaultGateway: "192.168.1.1",
    primaryDNS: "8.8.8.8",
    secondaryDNS: "0.0.0.0",
    dhcpEnable: 1,
    productCategory: surveillanceProductCategoryOption.ipcam,
    hardwareRevision: "A1",
    deviceIPType: 0,
    managedByNMS: 0,
    nmsURL: "",
    mgmtStatus: 1,
    mgmtMode: "UNP",
    authStatus: "failed",
    protocolType: "sunell",
    username: "viewer",
    password: "viewer123",
  },
  {
    brandName: "D-LINK",
    productName: "D-Link NVR",
    modelName: "DNR-4020-08P",
    version: "1.09.05",
    deviceId: "0c:b6:d2:fa:45:36",
    ipStatus: 1,
    ipAddress: "192.168.1.106",
    webPortNumber: 443,
    subnetMask: "255.255.255.0",
    defaultGateway: "192.168.1.1",
    primaryDNS: "8.8.8.8",
    secondaryDNS: "0.0.0.0",
    dhcpEnable: 1,
    productCategory: surveillanceProductCategoryOption.nvr,
    hardwareRevision: "A2",
    deviceIPType: 0,
    managedByNMS: 0,
    nmsURL: "",
    mgmtStatus: 1,
    mgmtMode: "UNP",
    authStatus: "passed",
    protocolType: "sunell",
  },
  {
    brandName: "D-LINK",
    productName: "D-Link Camera",
    modelName: "DCS-6517",
    version: "3.01.00",
    deviceId: "0c:b6:d2:fa:45:37",
    ipStatus: 1,
    ipAddress: "192.168.1.107",
    webPortNumber: 443,
    subnetMask: "255.255.255.0",
    defaultGateway: "192.168.1.1",
    primaryDNS: "8.8.8.8",
    secondaryDNS: "0.0.0.0",
    dhcpEnable: 1,
    productCategory: surveillanceProductCategoryOption.ipcam,
    hardwareRevision: "B2",
    deviceIPType: 0,
    managedByNMS: 0,
    nmsURL: "",
    mgmtStatus: 1,
    mgmtMode: "UNP",
    authStatus: "failed",
    protocolType: "sunell",
  },
];

export const surveillanceDiscoveredDevicesSlice = createSlice({
  name: "surveillanceDiscoveredDevices",
  initialState: {
    resource: "surveillanceDiscovery",
    batchData: [...mockSurveillanceDiscoveredDevices],
    data: [...mockSurveillanceDiscoveredDevices],
  },
});

export default surveillanceDiscoveredDevicesSlice.reducer;
